import React from "react";
import styled from "styled-components/macro";

const StyledIntro = styled.div`
  width: 100%;
  padding: 20px;

  @media (min-width: 800px) {
    padding: 80px 176px;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: 800px) {
    flex-direction: row;
    justify-content: space-between;
  }

  p {
    margin: 0 0 1em;
  }

  & > * {
    @media (min-width: 800px) {
      flex-basis: 50%;
    }
    /* padding: 20px; */
  }

  & > *:first-child {
    padding-bottom: 20px;

    @media (min-width: 800px) {
      padding-bottom: 0;
      padding-right: 20px;
    }
  }
  /* & > *:last-child {

    padding-left: 20px;
    @media (min-width: 800px) {
    padding-left: 20px;
    }
  } */
`;

const Intro = ({ title, text }) => {
  return (
    <StyledIntro>
      <Content>
        <h2>{title}</h2>
        <p dangerouslySetInnerHTML={{ __html: text }}></p>
      </Content>
    </StyledIntro>
  );
};

Intro.propTypes = {};

export default Intro;
